import React from 'react';
import { Comment } from 'semantic-ui-react';
import ConversationComment from './ConversationComment';
import { Comment as IComment } from '@vidende/contracts';

interface ConversationCommentsProps {
    comments: IComment[] | undefined;
    currentUser: any;
    onEdit: (event: any, comment: any) => void;
    onDelete: (event: any, comment: any, deleted: boolean) => void;
    onReply: (event: any, comment: any) => void;
    readOnly?: boolean;
    // Threaded through ...restProps to each ConversationComment (and nested
    // reply groups); see ConversationComment for the avatar-injection rationale.
    ImageComponent?: React.ComponentType<any>;
}

const ConversationComments = ({
    comments,
    currentUser,
    ...restProps
}: ConversationCommentsProps) => {
    return (
        <Comment.Group>
            {comments &&
                comments.map((comment) => {
                    // Cast only: `undefined > 0` is false at runtime anyway.
                    if ((comment?.replies?.length as number) > 0)
                        return (
                            <>
                                <ConversationComment
                                    key={comment.id}
                                    canEdit={
                                        comment.creatorId ===
                                        currentUser.details.id
                                    }
                                    isCurrentUserCommentAuthor={
                                        comment.creatorId ===
                                        currentUser.details.id
                                    }
                                    comment={comment}
                                    {...restProps}
                                >
                                    <ConversationComments
                                        comments={comment.replies}
                                        currentUser={currentUser}
                                        {...restProps}
                                    />
                                </ConversationComment>
                            </>
                        );
                    return (
                        <ConversationComment
                            key={comment.id}
                            canEdit={
                                comment.creatorId === currentUser.details.id
                            }
                            isCurrentUserCommentAuthor={
                                comment.creatorId === currentUser.details.id
                            }
                            comment={comment}
                            {...restProps}
                        />
                    );
                })}
        </Comment.Group>
    );
};

export default ConversationComments;
